import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DateTimeAdapter } from 'ng-pick-datetime';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit {
  title = 'CM BFS';
  public validinput: RegExp = /^[^\s]+(\s+[^\s]+)*$/;
  idleState: string;
  timedOut: boolean;
  dataService: any;
  sessionService: any;
  originUrl: string;
  lastPing?: Date = null;
  constructor(dateTimeAdapter: DateTimeAdapter<any>,
    private router: Router,
    ) {
    dateTimeAdapter.setLocale('en-in');
  }

  ngOnInit(): void {
    if (environment.production) {
      if (location.protocol !== 'https:') {
        location.replace(`https:${location.href.substring(location.protocol.length)}`);
      }
    }

    this.purgeTrackingCookies();

    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.purgeTrackingCookies();
        if (e.url === '/monthlyreport'
          || e.url.startsWith('/users/')
          || e.url.startsWith('/dashboard')
        ) {
          document.body.classList.add('removeglobalfilter');
        } else {
          document.body.classList.remove('removeglobalfilter');
        }
      }
    });
  }

  private purgeTrackingCookies(): void {
    try {
      const cookies = document.cookie.split(';');
      for (const cookie of cookies) {
        const trimmed = cookie.trim();
        const eqPos = trimmed.indexOf('=');
        const name = eqPos > -1 ? trimmed.substring(0, eqPos) : trimmed;
        if (name.startsWith('_ga') || name.startsWith('_gid') || name.startsWith('_gat')) {
          const domains = [window.location.hostname, '.' + window.location.hostname, '.xenovex.com', 'xenovex.com', ''];
          for (const domain of domains) {
            const domainPart = domain ? `; domain=${domain}` : '';
            document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;${domainPart}; Secure; SameSite=Lax`;
          }
        }
      }
    } catch (e) {}
  }

  clearAllData() {
  }
}
